import React from 'react';
export function Footer() {
  return <footer className="py-16 border-t border-line bg-pistachio-100" data-id="element-86" data-mp="19j53j40hsmi0">
      <div className="container mx-auto px-4 text-center" data-id="element-87" data-mp="206j2vgr4o7dc">
        <div className="mb-8" data-id="element-88" data-mp="2f4tlnphr8a8y">
          <p className="text-2xl font-display font-bold text-ink mb-2 flex items-center justify-center gap-2" data-id="element-89" data-mp="2f53f5n20czje">
            <span aria-hidden="true" data-id="element-90" data-mp="2a6s4xb7swn0n">🌿</span> Close The Gap™
          </p>
          <p className="text-pistachio-800 font-medium mb-4" data-id="element-91" data-mp="1mfmnwsq4joor">
            El sistema de cocina semanal para argentinos que quieren comer bien, gastar
            menos y recuperar su tiempo.
          </p>
          <p className="text-muted max-w-xl mx-auto" data-id="element-92" data-mp="1w6h8lsnq2g83">
            Porque comer bien no debería costarte todos los domingos del año.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-ink/80 mb-12" data-id="element-93" data-mp="1rd65a1i4chkx">
          <a href="mailto:closethegap14@gmail.com" className="flex items-center gap-2 hover:text-pistachio-700 transition-colors" data-id="element-94" data-mp="13ntvp0ivq7i3">
            <span aria-hidden="true" data-id="element-95" data-mp="1eivhcd40cmzg">📧</span> closethegap14@gmail.com
          </a>
          <a href="https://www.instagram.com/closethegap14" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-pistachio-700 transition-colors" data-id="element-96" data-mp="1ij5oht3jdjfw">
            <span aria-hidden="true" data-id="element-97" data-mp="1s8z372yz6eod">📲</span> @closethegap14
          </a>
          <a href="https://www.recursoclosethegap.shop" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 hover:text-pistachio-700 transition-colors" data-id="element-98" data-mp="vk9jd73sfbzr">
            <span aria-hidden="true" data-id="element-99" data-mp="14lz9m9lxo4vy">🌐</span> www.recursoclosethegap.shop
          </a>
        </div>

        <p className="text-muted text-sm mb-8" data-id="element-100" data-mp="19gwf56k07w43">
          © Close The Gap™ 2025 — Todos los derechos reservados. Prohibida la reproducción
          y redistribución sin autorización expresa.
        </p>

        <p className="inline-block px-6 py-3 rounded-full bg-surface border border-line text-ink italic font-medium" data-id="element-101" data-mp="2l08v8vysjfj3">
          <span aria-hidden="true" data-id="element-102" data-mp="1qaxlfw7cg3to">🌿</span> "El próximo domingo puede ser diferente."
        </p>
      </div>
    </footer>;
}